// Section types always included in PDF regardless of selection
export const ALWAYS_INCLUDE_TYPES = [
  'kansisivu',
  'allekirjoitukset',
  'allekirjoitus',
  'johdanto',
  'kohteen_perustiedot',
  'lahtotiedot',
  'yhteenveto',
];

// Per-report-type section trees. id values must match report_sections.type in the DB.
export const REPORT_SECTION_DEFS = {
  'Ikkunoiden_ja_Ulko-ovien_Kuntoarvio': [
    {
      id: 'asuntojen_ikkunat',
      label: '6 Asuntojen ikkunat',
      subsections: [
        { id: 'asuntojen_ikkunat_yleista',    label: '6.1 Yleistä' },
        { id: 'asuntojen_ikkunat_tyypit',     label: '6.2 Osien tyypit ja kuntoluokitus' },
        { id: 'asuntojen_ikkunat_kunto',      label: '6.3 Ikkunoiden kunto' },
        { id: 'asuntojen_ikkunat_korjaukset', label: '6.4 Korjaussuositukset' },
        { id: 'asuntojen_ikkunat_kuvat',      label: '6.5 Kuvat' },
      ],
    },
    {
      id: 'yleisten_tilojen_ikkunat',
      label: '7 Yleisten tilojen ikkunat',
      subsections: [
        { id: 'yleisten_tilojen_ikkunat_yleista',    label: '7.1 Yleistä' },
        { id: 'yleisten_tilojen_ikkunat_tyypit',     label: '7.2 Osien tyypit ja kuntoluokitus' },
        { id: 'yleisten_tilojen_ikkunat_kunto',      label: '7.3 Ikkunoiden kunto' },
        { id: 'yleisten_tilojen_ikkunat_korjaukset', label: '7.4 Korjaussuositukset' },
        { id: 'yleisten_tilojen_ikkunat_kuvat',      label: '7.5 Kuvat' },
      ],
    },
    {
      id: 'asuntojen_parvekeovet',
      label: '8 Asuntojen parvekeovet',
      subsections: [
        { id: 'asuntojen_parvekeovet_yleista',    label: '8.1 Yleistä' },
        { id: 'asuntojen_parvekeovet_tyypit',     label: '8.2 Osien tyypit ja kuntoluokitus' },
        { id: 'asuntojen_parvekeovet_kunto',      label: '8.3 Ovien kunto' },
        { id: 'asuntojen_parvekeovet_korjaukset', label: '8.4 Korjaussuositukset' },
        { id: 'asuntojen_parvekeovet_kuvat',      label: '8.5 Kuvat' },
      ],
    },
    {
      id: 'yleisten_tilojen_ulko_ovet',
      label: '9 Yleisten tilojen ulko-ovet',
      subsections: [
        { id: 'yleisten_tilojen_ulko_ovet_yleista',    label: '9.1 Yleistä' },
        { id: 'yleisten_tilojen_ulko_ovet_tyypit',     label: '9.2 Osien tyypit ja kuntoluokitus' },
        { id: 'yleisten_tilojen_ulko_ovet_kunto',      label: '9.3 Ovien kunto' },
        { id: 'yleisten_tilojen_ulko_ovet_korjaukset', label: '9.4 Korjaussuositukset' },
        { id: 'yleisten_tilojen_ulko_ovet_kuvat',      label: '9.5 Kuvat' },
      ],
    },
  ],
};
